export default __webpack_public_path__ + "875158a750318d20779251f8024331ac.png";